import React from "react";
import NamedResourceList from "../curriculum/components/named-resource-list";
import {cvQualificationService} from "../../services/curriculum-resource-service";

const CvQualification = () => (
    <NamedResourceList title="Capacitações" newLabel="Nova capacitação" basePath="/cv/qualification"
                       queryKey="cv-qualifications" service={cvQualificationService}/>
);

export default CvQualification;
